/* DON'T EDIT THIS FILE: edit original and run build again */ import { typeCheckerCaughtResult } from "./type-checker-errors.ts";
import {
  TypeCheckerResult,
  TypeCheckerSchema,
  TypeCheckerStatus,
  WithAnyTypeCheckerSchemaOptions,
} from "./type-checker-types.ts";

export const typeCheckerResolveResult = (
  checker: WithAnyTypeCheckerSchemaOptions<TypeCheckerSchema>,
  value: unknown,
  path: string,
  result: TypeCheckerResult
): TypeCheckerResult => {
  if (result.status !== TypeCheckerStatus.ok) {
    if (checker.catch) {
      return typeCheckerCaughtResult(
        value,
        path,
        result,
        checker.catch(value, path, result)
      );
    }
  }
  return result;
};
